module.exports = __webpack_public_path__ + "static/media/12.fc916cd2.png";